(() => {
  const root = document.querySelector('product-info[id^="MainProduct-"]');
  if (!root) return;

  // Display labels only. The radio values and Shopify/Gelato variant identities stay intact.
  const sizes = [
    ['15x20', '15×20 cm', '6×8″'],
    ['20x25', '20×25 cm', '8×10″'],
    ['21x29.7', 'A4 · 21×29.7 cm', 'A4 · 8.27×11.69″'],
    ['27x35', '27×35 cm', '11×14″'],
    ['30x40', '30×40 cm', '12×16″'],
    ['a3', 'A3 · 29.7×42 cm', 'A3 · 11.69×16.54″'],
    ['30x45', '30×45 cm', '12×18″'],
    ['40x50', '40×50 cm', '16×20″'],
    ['a2', 'A2 · 42×59.4 cm', 'A2 · 16.54×23.39″'],
    ['45x60', '45×60 cm', '18×24″'],
    ['50x70', '50×70 cm', '20×28″'],
    ['a1', 'A1 · 59.4×84.1 cm', 'A1 · 23.39×33.11″'],
    ['60x90', '60×90 cm', '24×36″'],
  ];
  const country = (root.dataset.marketCountry || 'GB').toUpperCase();
  const storageKey = `ph:size-unit:${country}`;
  let unit;
  try { unit = localStorage.getItem(storageKey); } catch { /* Storage can be disabled. */ }
  if (unit !== 'cm' && unit !== 'in') unit = country === 'US' ? 'in' : 'cm';

  const displayFor = (value) => {
    const key = value.split('/')[0].replace(/\s+/g, '').toLowerCase();
    const match = sizes.find(([prefix]) => key.startsWith(prefix));
    if (!match) return { cm: value.split('/')[0].trim(), in: value.split('/').slice(1).join('/').trim() || value };
    return { cm: match[1], in: match[2] };
  };

  const apply = () => {
    let changed = root.dataset.sizeUnit !== unit;
    root.dataset.sizeUnit = unit;
    root.querySelectorAll('.ph-size-unit-switch [data-size-unit]').forEach((button) => {
      const pressed = button.dataset.sizeUnit === unit ? 'true' : 'false';
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    });
    root.querySelectorAll('.ph-size-picker input[type="radio"]').forEach((input) => {
      const label = input.nextElementSibling?.querySelector('.ph-size-label');
      const names = displayFor(input.value);
      const display = names[unit];
      if (label && label.textContent !== display) { label.textContent = display; changed = true; }
      if (input.dataset.sizeDisplay !== display) { input.dataset.sizeDisplay = display; changed = true; }
      if (input.nextElementSibling && input.nextElementSibling.title !== `${names.cm} / ${names.in}`) {
        input.nextElementSibling.title = `${names.cm} / ${names.in}`;
      }
    });
    const selected = root.querySelector('.ph-size-picker input:checked');
    const selectedText = root.querySelector('.ph-selected-size__value');
    if (selected && selectedText) {
      const display = selected.dataset.sizeDisplay || displayFor(selected.value)[unit];
      if (selectedText.textContent !== display) { selectedText.textContent = display; changed = true; }
    }
    if (changed) root.dispatchEvent(new Event('ph:size-unit-change'));
  };

  root.addEventListener('click', (event) => {
    const button = event.target.closest('.ph-size-unit-switch [data-size-unit]');
    if (!button) return;
    unit = button.dataset.sizeUnit;
    try { localStorage.setItem(storageKey, unit); } catch { /* Preference is optional. */ }
    apply();
  });
  new MutationObserver(apply).observe(root, { childList: true, subtree: true });
  apply();
})();
